import React from 'react';
import {connect} from "react-redux";
import ContactList from '../../../../master/contact/helper/component/ContactList.js';

export class ContactScreen extends React.Component {
/*  constructor(props) {
    super(props);
  }*/

  render() {
    return (
      <div className="animated fadeIn">
        <div className="row">
          <div className="col-md-12">
            <div className="card">
              <div className="card-block">
                <ContactList {...this.props} />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    UserReducer : state.UserReducer,
  }
}

export default connect(mapStateToProps)(ContactScreen);



// WEBPACK FOOTER //
// ./src/App/views/templates/dashboard/master/contact.js